import React from 'react'

const deliveryZonesRoutes = [
    {
        path: '/Settings/DeliveryZones',
        component: React.lazy(() => import('./DeliveryZonesPage')),
    },
]

export default deliveryZonesRoutes
